<template>
  <div class="Agreement">
    <div class="backHome" @click="goToLogin">返回<br>首页</div>
    <div class="Agreement-title">青岛万嘉集运物流有限公司</div>
    <div class="Agreement-subtitle">用户服务协议</div>
    <div class="Agreement-text">
      <h4>第一条 总则</h4>
      <p>1.1 欢迎您与我方平台经营者（详见定义条款）共同签署本《用户服务协议》（下称“本协议”），并使用我方平台服务！</p>
      <p>1.2 各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，请您仔细阅读并严格遵守本《用户服务协议》全部条款和条件的具体表述（包括其不时的更新和修改），和我方平台上已发布的以及此后不时更改或发布的各项规则、政策、通知及公告。以下凡提及“本协议”，均应视为同时包含本《用户平台协议》（及其不时的更新和修改）以及我方平台上已发布的以及此后不时更改或发布的各项规则、政策、通知及公告。</p>
      <p>1.3 您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容（特别是针对有关服务的约定、免除或者限制责任的条款、终止及违约责任的约定及法律适用和争议解决条款）。为方便您的阅读和理解，部分条款做了加粗和下划线提示。您点击同意本协议后，视为您已确认我方平台已经完整详尽地履行了本协议所有内容的告知义务及我方平台本协议所有内容条款（无论是否加粗和下划线）均满足了《民法典》第四百九十六条规定的采取合理的方式提请您注意免除或者限制您责任的条款要求。如您对协议有任何疑问，可向我方平台客服咨询。</p>
      <p>1.4 当您按照预定页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我方达成一致， 成为我方平台“用户”，并确认您因工作需要使用我方平台服务时，您已经充分获得您工作单位的授权。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</p>
      <p>1.5 我方平台有权根据法律法规的变化及/或运营需要不定时修改本协议条款，并提前以公示、推送通知或弹窗方式通知到您。您可以随时在本平台查阅修改后的最新版本协议。经修订的协议一经在本平台公布，立即产生效力，如果您在本协议更新后继续使用本平台服务，即视为您已接受修改后的协议。当您与本平台发生争议时，应以最新版本的“本协议”为准，如您不同意修改后的协议，请立即停止使用本平台服务。</p>
      <p>1.6 如果您未申请注册流程，或者在本协议生效前已成为我方平台的注册用户，则如此协议生效后，您继续访问和/或使用我方平台网站，即视为您表示同意接受本协议的全部内容，且本协议生效之日追溯至您首次访问本平台之日，对您在我方平台使用过的所有服务有效，如您对不同意本协议或其中任何条款约定，请您停止访问或使用我方平台网站。</p>
    </div>
    <div class="Agreement-text">
      <h4>第二条 定义</h4>
      <p>2.1 我方平台：指我司提供的网站，小程序及相关客户端。</p>
      <p>2.2 我方/我方平台经营者：指我司。</p>
      <p>2.3 我方平台服务：我方基于互联网，以包含我方平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。</p>
      <p>2.4 我方平台规则：包括在所有我方平台网站内已经发布及后续发布的全部协议、规则、解读、公告、站内消息等内容以及各平台在频道板块、页面、帮助中心等发布的各类协议、规则、实施细则、产品说明、公告等。</p>
    </div>
    <div class="Agreement-text">
      <h4>第三条 协议范围</h4>
      <p>3.1 签约主体</p>
      <p>3.1.1 本协议由您与我方平台经营者共同缔结，本协议对您与我方平台经营者均具有合同效力。</p>
      <p>3.1.2 我方平台经营者是指经营我方平台的法律主体，您可根据以上定义条款确定与您履约的我方主体。本协议项下，我方平台经营者可能根据我方平台的业务调整而发生变更，变更后的我方平台经营者与您共同履行本协议并向您提供服务，我方平台经营者的变更不会影响您本协议项下的权益。我方平台经营者还有可能因为提供新的我方平台服务而新增，如您使用新增的我方平台服务的，视为您同意新增的我方平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</p>
      <p>3.2 补充协议 我方平台规则：包括在所有我方平台网站内已经发布及后续发布的全部协议、规则、解读、公告、站内消息等内容以及各平台在频道板块、页面、帮助中心等发布的各类协议、规则、实施细则、产品说明、公告等。</p>
      <p>3.2.1 由于互联网行业高速发展，您与我方签署的本协议列明的条款并不能完整罗列并覆盖您与我方所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，我方平台公示的各种通告、相关声明及政策、我方平台规则和协议均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用我方平台服务，视为您同意上述补充协议。</p>
    </div>
    <div class="Agreement-text">
      <h4>第四条 账户注册与使用</h4>
      <p>4.1 用户资格</p>
      <p>4.1.1 您确认，在您完成注册程序并实际使用我方平台服务时，您应当是具备相应民事行为能力的自然人（十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人）、法人或其他组织。若您不具备前述主体资格，我方平台有权拒绝您的注册/使用申请；如您已经注册，则我方平台有权对您的账户进行相应的限制，且您及您的家长或法定监护人（以下统称"监护人"）应承担因此而导致的一切后果；如您的行为给我方平台造成损失的，我方平台保留向您及您的监护人索偿的权利。</p>
      <p>4.2 账户说明</p>
      <p>4.2.1 当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得我方平台账户并成为我方平台用户。</p>
      <p>4.2.2 您有权使用您设置或确认的我方会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录我方平台。</p>
      <p>4.2.3 由于用户账户关联用户信息，仅当有法律明文规定、司法裁定或经我方同意，并符合我方平台规则规定的用户账户转让流程的情况下，您才可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。</p>
      <p>4.2.4 为使您更好地使用我方平台的各项服务，我方建议您按照我方平台要求及相关法律规定完成实名认证。</p>
      <p>4.2.5 如您的账户长期未登录，我方有权予以进行注销等清理，您的账户将不能再登录任一我方平台，相应服务同时终止。我方在对此类账户进行清理前，将以包括但不限于网站公告、站内消息、客户端推送信息等方式通知您。</p>
      <p>4.2.6 我方平台对您账号的实际使用人/操作人与账号的注册人/申请人之间的关系不具有核查义务，任何通过您的账号使用我方平台服务的行为均视为您的行为，由您自行承担因该行为而产生的一切责任。</p>
      <p>4.2.7 您理解并且同意：您账号中止、暂停、停止使用或注销，均不代表您责任的终止，无论该账号的“不使用”是因何原因造成，您仍然对使用我方平台期间的一切行为承担责任。</p>
      <p>4.3 注册信息管理</p>
      <p>4.3.1 真实合法</p>
      <p>4.3.1.1 在使用我方平台服务时，您应当按我方平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便我方在必要时与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。</p>
      <p>4.3.1.2 您所设置的账户名不得违反国家法律法规及我方平台规则关于账户名的管理规定，否则我方可对您的账户名进行暂停使用或注销等处理，并向主管机关报告。</p>
      <p>4.3.1.3 您理解并承诺，您的账户名称、头像和简介等注册信息中不得出现违法和不良信息，没有冒用关联机构或社会名人，您在账户注册过程中需遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。</p>
      <p>4.3.1.4 您同意并授权，为了更好的为您提供服务以及确保您的账户安全，我方可以根据您提供的手机号码、身份证号码等信息，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。</p>
      <p>4.3.2 更新维护</p>
      <p>4.3.2.1 您应当及时更新您提供的信息，在法律有明确规定或有关部门明确要求我方对部分用户的信息进行核实的情况下，我方将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。</p>
      <p>4.3.2.2 如我方按您最后一次提供的信息与您联系未果、您未按照我方的要求及时提供信息、您提供的信息存在不实的，您将承担因此对您自身、他人及我方造成的全部损失与不利后果。</p>
      <p>4.4 账户安全规范</p>
      <p>4.4.1 您的账户为您自行设置并由您保管。建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开我方平台。</p>
      <p>4.4.2 账户因您主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，我方平台并不承担任何责任，您应通过司法、行政等救济途径向侵权行为人追偿。</p>
      <p>4.4.3 您的账户只限您本人使用，不得出借或分享他人使用。当您的账户遭到未经授权的使用时，您应当立即通知我方平台，否则未经授权的使用行为均视为您本人的行为，您将自行承担所有由此导致的损失及后果。</p>
      <p>4.4.4  如发现任何未经授权使用您账户登录我方平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知我方。您理解我方对您的任何请求采取行动均需要合理时间，除我方存在过错外，我方对在采取行动前已经产生的后果不承担任何责任。</p>
      <p>4.4.5 除我方存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、订购商品及服务及披露信息等）负责。</p>
    </div>
    <div class="Agreement-text">
      <h4>第五条 我方平台服务及规范</h4>
      <p>5.1 我方平台服务</p>
      <p>5.1.1 我方平台向您提供包括但不限于以下服务：</p>
      <p>（一） 网站，微信小程序等我方直接所有或运营的任何网站及相关客户端</p>
      <p>（二） 我方直接拥有或运营网站的客户端包括但不限于 PC、平板、手机、电视、机顶盒等全部终端的客户端</p>
      <p>（三）其他由我方运营并适合提供的服务。</p>
      <p>（以上服务统称为“我方平台服务”）。</p>
      <p>5.1.2 我方平台服务，均仅限于您在我方平台使用。任何以恶意破解等非法手段将我方服务与我方平台分离的行为，均不属于本协议中约定的我方服务。由此引起的一切法律后果由行为人负责，我方有权利依法追究行为人的法律责任。</p>
      <p>5.1.3 我方平台网站官方公布的方式为下载、注册、登录、使用我方服务的唯一合法方式，您通过其他任何渠道、任何途径、任何方式获取的我方服务（包括且不限于账户、积分、等级、优惠券、赠品、下载等）均为非法取得，我方概不承认其效力，且一经发现我方有权立即做出删除、取消、清零、封号等处理，任何因此导致的一切不利后果均由您自行承担。</p>
      <p>5.1.4 我方有权向您公告（包括但不限于以弹出页面、网站公告、站内消息等方式）以修改、替换、升级与我方平台服务相关的任何软件。如果您不同意或者不接受我方平台服务相关软件的修改、替换、升级，请直接拒绝、停止、取消并立即停止使用我方平台，否则您的一切使用行为均视为您同意并接受我方平台相关软件的修改、替代、升级，同时该同意并接受的行为仍受本协议约束。</p>
      <p>5.1.5 您理解并认可，您使用我方平台网站或我方平台账户所获得的包括但不限于使用记录、订阅、收藏、积分、等级、身份标识、优惠券、虚拟赠品、下载等衍生物，您确认对其不享有所有权（除非我方平台另有公告说明），我方许可您按照我方平台规则进行使用，我方的包括但不限于保有、使用、删除上述衍生物等行为不存在任何侵权，不承担任何赔偿责任。</p>
      <p>5.1.6 您同意并保证，不得利用我方平台服务或其衍生物（包括但不限于账户、积分、等级、优惠券、活动赠品、下载等服务）进行倒卖、转手、置换、抵押有价交易等方式非法牟利。您不会利用我方平台服务或其衍生物侵犯他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段窃取、盗用他人的账户、积分、优惠券等。</p>
      <p>5.1.7 您理解并认可，如果您通过第三方支付工具在我方平台账户支付或充值后可能产生的任何商业风险（包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动），该等风险均有可能给您造成相应的经济损失，我方在已经履行本协议项下义务和法律规定的前提下，不对您的前述风险和损失承担任何责任。</p>
      <p>5.2 服务规范</p>
      <p>5.2.1 您可通过我方平台服务在我方平台上传、发布或传输相关内容，包括但不限于文字、图形、图片、文档等信息或其他资料（下称“内容”），但您需保证您上传、发布或传输的内容合法、客观、真实，与本平台经营者或平台内经营者提供的商品及/或服务具有关联性，且不应包含任何污言秽语、色情低俗、政治敏感、广告信息及法律法规与本协议列明的其他禁止性信息，您将自行对上述内容承担相关的法律责任，且我方平台可按照平台规则的相关规定对您实施上述行为所产生的评价信息采取必要处置措施。</p>
      <p>5.2.2为方便您使用我方和我方关联公司的其他相关服务，您授权我方将您在账户注册和使用我方平台服务过程中提供、形成的信息传递给我方关联公司等其他相关服务提供者，或从我方关联公司等其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。</p>
      <p>5.2.3 您理解并知晓在使用我方平台服务时，所接触的内容和信息来源广泛，我方无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。您理解并认可您可能会接触到不正确的、不适当的或令人厌恶的内容和信息，您不会以此追究我方的相关责任。我方不对用户在我方平台上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。</p>
      <p>5.2.4 您同意我方在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在我方平台的任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受我方通过电子邮件、站内短信、手机短信、网站公告或其他方式向您发送促销或其他相关商业信息。</p>
      <p>5.2.5 您同意在使用我方平台服务过程中，遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规。在任何情况下，我方一旦合理地认为您的行为可能违反上述法律、法规， 可以在任何时候，不经事先通知终止向您提供服务。您应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。</p>
      <p>5.3 禁止的内容</p>
      <p>5.3.1 您理解并保证您在我方平台上传、发布或传输的内容（包括您的账户名称等信息）不含有以下内容：</p>
      <p>（一）反对宪法确定的基本原则的；</p>
      <p>（二）危害国家统一、主权和领土完整的；</p>
      <p>（三）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
      <p>（四）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
      <p>（五）宣扬邪教、迷信的；</p>
      <p>（六）扰乱社会秩序，破坏社会稳定的；</p>
      <p>（七）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；</p>
      <p>（八）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；</p>
      <p>（九）危害社会公德，损害民族优秀文化传统的；</p>
      <p>（十）有关法律、行政法规和国家规定禁止的其他内容。</p>
      <p>5.3.2 如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，您将直接承担以上内容导致的一切不利后果。如因此给我方造成不利后果的，您应负责消除影响，并且赔偿我方因此受到的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费、诉讼费、保全费、鉴定费等因维权而产生的合理费用。</p>
      <p>5.4 禁止的行为</p>
      <p>5.4.1 您理解并保证不就我方平台服务进行下列的禁止的行为，也不允许任何人利用您的账户进行下列行为，如有违反，承担一切法律责任，并赔偿我方因此受到的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费、诉讼费、保全费、鉴定费等因维权而产生的合理费用：</p>
      <p>（一）在注册账户时，或使用我方平台服务时，冒充他人，或讹称与任何人、任何单位或实体有联系（包括设置失实的账户名称或接入另一用户的账户）；</p>
      <p>（二）伪造标题或以其他方式操控内容，使他人误认为该内容为我方所传输；</p>
      <p>（三）将无权传输的内容（例如内部资料、机密资料、侵犯他人知识产权的资料）进行上传、发布、发送电子邮件或以其他方式传输；</p>
      <p>（四）发送任何未获邀约或未经授权的垃圾电邮、广告或宣传资料，或任何其他商业通讯；</p>
      <p>（五）未经我方明确许可，使用我方平台服务用于任何商业用途或为任何第三方的利益；</p>
      <p>（六）跟踪或以其他方式骚扰他人；</p>
      <p>（七）参与任何非法或有可能非法（由我方判断）的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；</p>
      <p>（八）赌博、提供赌博数据或透过任何方法诱使他人参与赌博活动；</p>
      <p>（九）使用或利用我方知识产权（包括我们的商标、品牌、标志、任何其他专有数据或任何网页的布局或设计），或在其他方面侵犯我方任何知识产权（包括试图对我方平台客户端或所使用的软件进行逆向工程）；</p>
      <p>（十）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入我方平台服务、收集或处理通过我方平台服务所提供的内容；</p>
      <p>（十一）参与任何“框架”、“镜像”或其他技术，目的是模仿我方平台服务的外观和功能；</p>
      <p>（十二）干预或试图干预任何用户或任何其他方接入我方平台服务；</p>
      <p>（十三）故意散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；</p>
      <p>（十四）未经他人明确同意，分享或发布该等人士可识别个人身份的资料；</p>
      <p>（十五）探究或测试我方平台服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）我方平台服务、系统或其他用户的系统的任何安全功能；</p>
      <p>（十六）对我方平台服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；</p>
      <p>（十七）为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量数据和信息；</p>
      <p>（十八）故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。</p>
    </div>
    <div class="Agreement-text">
      <h4>第六条 隐私权政策</h4>
      <p>6.1我方非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用我方提供的服务时，您同意我方按照在我方平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。我方希望通过隐私权政策向您清楚地介绍我方对您个人信息的处理方式，因此我方建议您完整地阅读隐私权政策，以帮助您更好地保护您的隐私权。</p>
      <p>6.2如您对本隐私权政策有任何疑问，您可以通过我方平台公布的联系方式与我们联系。如果您不同意本隐私权政策任何内容，您应立即停止使用我方平台服务。当您使用我方平台提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。</p>
      <p>6.3 适用范围</p>
      <p>6.3.1本隐私权政策适用于我方平台提供的所有服务，您访问我方平台网站及/或登录相关客户端使用我方平台提供的服务，均适用本隐私权政策。</p>
      <p>6.3.2需要特别说明的是，本隐私权政策不适用于其他第三方向您提供的服务，例如我方平台上的第三方依托我方平台向您提供服务时，您向第三方提供的个人信息不适用于本隐私权政策，我方对任何第三方使用由您提供的信息不承担任何责任。</p>
      <p>6.3.3我方将遵循由中国广告协会互动网络分会颁布的《中国互联网定向广告用户信息保护框架标准》，基于合法、合理和诚实信用的法定原则妥善处理或使用您的个人信息。</p>
      <p>6.4 我们如何收集信息</p>
      <p>我们收集信息是为了向您提供更好、更优、更个性化的服务，我们收集信息的方式如下：</p>
      <p>（一）您向我们提供的信息。</p>
      <p>（1）当您注册我方账户及您在使用我方平台提供的相关服务时填写及/或提交的信息，包括您的姓名、性别、出生年月日、身份证号码、电话号码、QQ、微信号、电子邮箱、地址、兴趣爱好、支付账户及相关附加信息（如您所在的省份和城市、邮政编码、公司名称、公司营业执照、办公地址等）。</p>
      <p>（2）您使用我方平台服务时所储存的信息。</p>
      <p>（二）在您使用服务过程中收集的信息。</p>
      <p>为了提供并优化您需要的服务，我们会收集您使用服务的相关信息，这类信息包括：</p>
      <p>（1）在您使用我方平台服务，或访问我方平台页面时，我方自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；如您下载或使用我方或其关联公司客户端软件，或访问移动网页使用我方平台服务时，我方可能会读取与您位置和移动设备相关的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。</p>
      <p>（2）您通过我方的内容上传/发布服务所上传/发布的内容所包含的信息，例如询盘等具体信息等。</p>
      <p>（3）除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我方的关联方、我方合作伙伴之间互动时我们收集的相关信息。与此同时，为提高您使用我方平台提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</p>
      <p>（三）来自第三方的信息。</p>
      <p>为了给您提供更好、更优、更加个性化的服务，或共同为您提供服务，或为了预防互联网欺诈的目的，我方的关联方、合作伙伴会依据法律的规定或与您的约定或征得您同意的前提下，向我方分享您的个人信息。</p>
      <p>您了解并同意，以下信息不适用本隐私权政策：</p>
      <p>（1）您在使用我方平台提供的搜索服务时输入的关键字信息；</p>
      <p>（2）违反法律规定或违反我方规则行为及我方已对您采取的措施；</p>
      <p>（3）应法律法规要求需披露的个人信息；</p>
      <p>（4）紧急情况下，为维护用户及公众的利益。</p>
      <p>6.5 我们如何使用信息</p>
      <p>因收集您的信息是为了向您提供服务及提升服务质量的目的，为了实现这一目的，我们会把您的信息用于下列用途：</p>
      <p>（一）在我方平台，如网站及应用中，需要在信息条板块、“联系TA”按钮处、检索板块等展示您的昵称、姓名、手机号、邮箱号及您所在的公司名等。（特别注意，如果您不同意展示此类信息，请您停止使用平台/软件并联系我方人员对您的信息进行删除/屏蔽等处理）</p>
      <p>（二）向您提供您使用的各项服务，并设计、维护、改进这些服务。</p>
      <p>（三）向您推荐您可能感兴趣的内容，包括但不限于向您发出产品和服务信息，或通过系统向您展示个性化的第三方推广信息，或者在征得您同意的情况下与我方的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。</p>
      <p>（四）向您提供与您更加相关的广告以替代普遍投放的广告。</p>
      <p>（五）我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、其他我们用户，或我们或其关联方的合法权益。</p>
      <p>（六）我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露。</p>
      <p>（七）让您参与有关我们产品和服务的调查，或者促销及抽奖活动。</p>
      <p>（八）经您许可的其他用途。</p>
      <p>6.6我们如何共享信息</p>
      <p>我们对您的信息承担保密义务，不会出售或出租您的任何信息，我们会在满足下列情况之一下才将您的信息与第三方共享：</p>
      <p>（一）您同意《用户服务协议》及本隐私政策，并开始使用平台功能，很多功能对您个人信息会进行部分展示与共享；或其他事先获得您的同意或授权。</p>
      <p>（二）根据法律法规的规定或行政或司法机构的要求。</p>
      <p>（三）向我方的关联方分享您的个人信息。</p>
      <p>（四）向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理这些信息。</p>
      <p>（五）如您是适格的投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。</p>
      <p>（六）只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。例如您在我方平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，我方会视情况向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
      <p>（七）如您出现违反中国有关法律、法规或者我方相关协议或相关规则的情况，需要向第三方披露。</p>
      <p>（八）为维护我方及其关联方或用户的合法权益。</p>
      <p>6.7 Cookie的使用</p>
      <p>6.7.1为使您获得更轻松的访问体验，您访问我方平台网站或使用我方平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</p>
      <p>6.7.2请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我方的Cookie，但这一举动在某些情况下可能会影响您安全访问我方平台相关网站和使用我方平台提供的服务。</p>
      <p>6.8 信息存储</p>
      <p>我方收集的有关您的信息和资料将保存在我方及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或我方收集信息和资料所在地并在该地被访问、存储和展示。</p>
      <p>6.9您的个人信息保护</p>
      <p>6.9.1为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将尽力做到使您的信息不被泄漏、毁损或丢失。</p>
      <p>6.9.2您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我方将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</p>
      <p>6.9.3在使用我方平台服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如公司名称、银行账户信息、联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我方客服，以便我方采取相应措施。</p>
      <p>6.10 未成年人保护</p>
      <p>我们不会在知情的情况下收集未成年人的个人信息。除非所在地法律允许并且监护人同意，未成年人请不要注册账户或发送自己的姓名、住址、电话、邮件地址等个人信息给我们。如果我们不小心收集到了未成年人的信息，我们在知情后会尽快删除。如果您认为我们可能不当地持有来自于或关于未成年人的信息，请联系我们。</p>
      <p>第七条 第三方链接</p>
      <p>我方平台服务可能会包含与其他网站或资源的链接，包括但不限于广告外链等。访问这些链接将由您自己做出决定，我方平台并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或者保证。我方对于前述广告外链网站或资源的内容、隐私政策和活动，没有控制、审查或修改的权力和义务，因而也不承担任何责任。我方建议您在离开我方平台，访问其他网站或资源前仔细阅读第三方平台的服务条款和隐私政策，考虑并自行承担由此带来的一切风险和结果。</p>
      <p>第八条 知识产权</p>
      <p>8.1 除非另有约定或我方另行声明，我方平台内的所有内容、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、图表、色彩、电子文档等）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等） 及相关权利，均归我方或我方关联公司所有。未经我方许可，任何人不得擅自使用（包括但不限于复制、传播、展示、镜像、上载、下载、修改、出租），否则我方将依法追究其法律责任。</p>
      <p>8.2 我方平台的 Logo等文字、图形及其组合，以及我方平台的其他标识、徵记、产品和服务名称均为我方或我方关联公司所有，未经我方书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。一有违反，则对我方平台的使用权将立即终止，且任何人必须按照我方平台的要求，归还或销毁使用我方平台任何部分的内容所创建的资料的任何副本。</p>
      <p>8.3 我方对我方专有内容、PGC 内容和其他通过授权取得的独占或独家内容享有完整权利。未经我方许可，任何单位和个人不得私自转发、传播和提供交易服务或者有其他侵犯我方权利的行为，否则将承担所有相关的法律责任。</p>
      <p>8.4  除非有相反证明，我方将视您为您在我方平台上传、发布或传输的内容的版权拥有人。您使用我方平台服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销的、免费的授予我方对该内容的存储、使用、发布、复制、修改、改编、出版、翻译、据以创作衍生品、传播和展示等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您的上传、发布的内容进行商业开发的权利；通过有线或无线网络向您的计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）、手持数字影音播放设备、电视接收设备（模拟信号接收设备、数字信号接收设备、数字电视、IPTV、带互联网接入功能的播放设备等）等提供包括但不限于信息的浏览、点击、数据传输及其相关的宣传和推广等服务的权利；以及再授权给其他第三方以上述方式使用的权利。</p>
      <p>8.5用户一旦接受本协议，即表明该用户主动将其在任何时间段在本平台发表的任何形式的信息内容（包括但不限于用户评价、用户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给我方平台所有，用户同意我方平台有权就任何主体侵权而单独提起诉讼。</p>
      <p>8.6本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2010年版著作权法确定）及相关法律规定的著作财产权等权利转让的书面协议，其效力及于用户在我方平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
      <p>8.7 用户通过我方平台发布的信息或内容，并不代表我方之意见及观点，也不意味着我方平台赞同其观点或证实其内容的真实性。我方平台有权删除网站内各类不符合法律或本协议规定的信息或内容，而保留不通知用户的权利。</p>
      <p>8.8 用户通过我方平台发布的信息、文字、图片等资料均由我方平台用户提供，其真实性、准确性和合法性由信息发布人负责。我方平台不提供任何保证，并不承担任何法律责任。如果以上资料侵犯了第三方的知识产权或其他权利，责任由信息发布者本人承担，我方平台对此不承担责任。</p>
      <p>8.9 除法律另有强制性规定外，未经我方平台明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、传播、展示、镜像、上载、下载、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，我方平台有权追究其法律责任。</p>
      <p>8.10 我方平台以下内容不可任意转载：</p>
      <p>1）本平台内发布的所有信息；</p>
      <p>2）已作出不得转载或未经许可不得转载声明的内容；</p>
      <p>3）本平台中特有的图形、标志、页面风格、编排方式、程序等；</p>
      <p>4）本平台中必须具有特别授权或具有注册用户资格方可知晓的内容；</p>
      <p>5）其他法律不允许或本平台认为不适合转载的内容。</p>
      <p>8.11 对于不当引用我方平台内容而引起的纷争等或因纠纷等造成的任何损失，我方平台不承担相关法律责任。对不遵守本声明的用户或其他违法、恶意使用我方平台网站内容者，我方平台保留追究其法律责任的权利。</p>
    </div>
    <div class="Agreement-text">
      <h4>第九条 用户的违约及处理</h4>
      <p>9.1 违约认定</p>
      <p>发生如下情形之一的，视为您违约：</p>
      <p>（一）使用我方平台服务时违反有关法律法规规定的；</p>
      <p>（二）违反本协议或本协议补充协议（即本协议第 3.2 条）约定的。</p>
      <p>9.2 为适应互联网行业发展和满足海量用户对高效优质服务的需求，您理解并同意，我方可在我方平台规则中约定违约认定的程序和标准。如：我方可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</p>
      <p>9.3 违约处理措施</p>
      <p>9.3.1 您在我方平台上发布的内容和信息构成违约的，我方可根据相应规则立即对相应内容和信息进行删除、屏蔽等处理或对您的账户进行暂停使用、查封、注销等处理。</p>
      <p>9.3.2 您在我方平台上实施的行为，或虽未在我方平台上实施但对我方平台及其用户产生影响的行为构成违约的，我方可依据相应规则对您的账户执行限制参加活动、中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的， 我方可查封您的账户，终止向您提供服务。</p> 
      <p>9.3.3 如果您在我方平台上的行为违反相关的法律法规，我方可依法向相关主管机关报告并提交您的使用记录和其他信息。</p>
      <p>9.4 赔偿责任</p>
      <p>9.4.1 如您的行为使我方及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿我方及/或其关联公司的上述全部损失。</p>
      <p>9.4.2 如您的行为使我方及/或其关联公司遭受第三人主张权利，我方及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿，损失包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费、诉讼费、保全费、鉴定费等因维权而产生的合理费用。</p>
      <p>9.5 特别约定</p>
      <p>9.5.1 我方向您提供我方平台服务。我方依法律规定承担相应义务，但无法对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，黑客活动、计算机病毒、电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。</p>
      <p>9.5.2 我方通过中华人民共和国境内的设施控制和提供我方平台服务，我方不担保控制或提供的服务在其他国家或地区是适当的、可行的，任何在其他司法辖区使用我方平台服务的用户应自行确保其遵守当地的法律法规，我方对此不承担任何责任。</p>
    </div>
    <div class="Agreement-text">
      <h4>第十条 协议的变更</h4>
      <p>10.1 我方可根据国家法律法规变化及我方平台服务变化的需要，不时修改本协议、补充协议或平台相关协议、规则等，变更后的协议、补充协议、平台相关协议、规则（下称“变更事项”）将通过本协议第十一条约定的方式通知您。</p>
      <p>10.2 如您对变更事项不同意的，您应当于变更事项确定的生效之日起停止使用我方平台服务；如您在变更事项生效后仍继续使用我方平台服务，则视为您同意已生效的变更事项。</p>
    </div>
    <div class="Agreement-text">
      <h4>第十一条 通知</h4>
      <p>您同意我方可采取以下任一合理的方式向您送达各类通知：</p>
      <p>（一） 公示的文案或更新在网站；</p>
      <p>（二） 您在操作时附带的说明、规则、协议等；</p>
      <p>（三） 站内消息、弹出消息、客户端推送的消息；</p>
      <p>（四） 根据您预留于我方平台的联系方式发出的电子邮件、手机短信、函件等。</p>
    </div>
    <div class="Agreement-text">
      <h4>第十二条 通知</h4>
      <p>12.1 终止的情形</p>
      <p>您有权通过以下任一方式终止本协议：</p>
      <p>（一）在满足我方平台网站公示的账户注销等清理条件时您通过网站注销您的账户的；</p>
      <p>（二）变更事项生效前您停止使用并明示不愿接受变更事项的；</p>
      <p>（三）您明示不愿继续使用我方平台服务，且符合我方平台终止条件的。</p>
      <p>出现以下情况时，我方可以本协议第十一条的所列的方式通知您终止本协议： </p>
      <p>（1）您违反本协议约定，我方依据违约条款终止本协议的；</p>
      <p>（2）您转让本人账户、盗用他人账户、发布违禁内容和信息、骗取他人财物、采取不正当手段谋利等行为，我方依据我方平台规则对您的账户予以查封的；</p>
      <p>（3）除上述情形外，因您多次违反我方平台规则相关规定且情节严重，我方依据我方平台规则对您的账户予以查封的；</p>
      <p>（4）您的账户被我方依据本协议进行注销等清理的；</p>
      <p>（5）您在我方平台有侵犯他人合法权益或其他严重违法违约行为的；</p>
      <p>（6）其它根据相关法律法规我方应当终止服务的情况。</p>
      <p>12.2 协议终止后的处理</p>
      <p>本协议终止后，除法律有明确规定外，我方无义务向您或您指定的第三方披露您账户中的任何信息。</p>
      <p>本协议终止后，我方享有下列权利：</p>
      <p>（一）停止收集您的个人信息，但可继续保存和基于共赢目的使用您留存于我方平台的其他内容和信息；</p>
      <p>（二）对于您过往的违约行为，我方仍可依据本协议向您追究违约责任。</p>
    </div>
    <div class="Agreement-text">
      <h4>第十三条 法律适用、管辖与其他</h4>
      <p>13.1 本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p>
      <p>13.2 您因使用我方平台服务所产生及与我方平台服务有关的争议，由我方与您协商解决。协商不成时，由平台经营者住所地人民法院管辖。</p>
      <p>13.3 本协议任一条款被视为废止、无效或不可执行，该条应视为独立可分的且并不影响本协议其余条款的有效性及可执行性。</p>
    </div>
    <div class="Agreement-text">
      <h4>第十四条 完整协议</h4>
      <p>本协议由《用户平台服务协议》条款与《客户端软件许可及使用协议》、《隐私权政策》、《版权声明》、《客户权益保障承诺书》等我司后续可能不时公示的各项规则组成，各项规则有约定，而本协议条款没有约定的，以各项规则约定为准。本协议部分内容被有管辖权的法院认定为违法或无效的，不因此影响其他内容的效力。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  data() {
    return {

    }
  },

  methods: {
    goToLogin() {
      this.$router.push({
        path: '/Login'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Agreement {
  width: 1260px;
  background: #fff;
  margin: 0 auto;

  .backHome {
    position: fixed;
    right: 15px;
    bottom: 100px;
    color: #fff;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    font-size: 14px;
    background: #073290;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
    &:hover {
      cursor: pointer;
    }
  }

  .Agreement-title {
    padding: 20px 0;
    color: #073290;
    text-align: center;
    font-size: 26px;
    font-weight: 550;
    border-bottom: 1px solid #eee;
  }

  .Agreement-subtitle {
    padding: 15px 0;
    color: #181818;
    text-align: center;
    font-size: 22px;
    font-weight: 550;
  }

  .Agreement-text {
    padding: 0 30px 20px 30px;
    margin-bottom: 10px;

    h4 {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 550;
      color: #181818;
    }

    p {
      margin-top: 4px;
      font-size: 14px;
      line-height: 26px;
      color: #4b4b4b;
    }
  }
}
</style>